import { render, staticRenderFns } from "./roomBindMeterWater.vue?vue&type=template&id=24394b80&scoped=true"
import script from "./roomBindMeterWater.vue?vue&type=script&lang=js"
export * from "./roomBindMeterWater.vue?vue&type=script&lang=js"
import style0 from "./roomBindMeterWater.vue?vue&type=style&index=0&id=24394b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24394b80",
  null
  
)

export default component.exports